import { useEffect } from 'react';

/**
 * Hook to rehydrate form data from submitted data after an error
 * Replaces the duplicated useEffect pattern in all form components
 *
 * @param {Function} setFormData - State setter for form data
 * @param {string|object} submittedData - Previously submitted form data (may be JSON string)
 * @param {string} errorCode - Error code from submission attempt
 */
export const useFormRehydration = (setFormData, submittedData, errorCode) => {
  useEffect(() => {
    if (submittedData !== null && errorCode !== '') {
      try {
        const data =
          typeof submittedData === 'string'
            ? JSON.parse(submittedData)
            : submittedData;
        setFormData(data);
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (e) {
        console.error('Failed to rehydrate form data:', e);
      }
    }
  }, [submittedData, errorCode, setFormData]);
};

export default useFormRehydration;
